import {AWSContent} from "./content/AWSContent";
import {FrameIOContent} from "./content/FrameIOContent";
import {Box, IconButton, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {Cancel, CheckCircle} from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
    check: {
        width: 30
    },
    date: {
        alignItems: "center",
        display: "flex",
        margin: theme.spacing(1),
        width: 90
    },
    dateHeader: {
        margin: theme.spacing(1),
        width: 90
    },
    tableCheck: {
        display: "flex",
        margin: theme.spacing(1),
        width: 90
    },
    tableRow: {
        display: "flex",
        flexGrow: 1
    },
    tableSoundBank: {
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        margin: theme.spacing(1)
    },
    format: {
        paddingTop: theme.spacing(3),
        marginTop: theme.spacing(8),
        transform: "rotate(315deg)",
        whiteSpace: "nowrap",
        width: 30
    },
    formatLabel: {
        borderBottom: "2px solid lightgrey"
    },
    table: {
        height: "100%",
        marginRight: theme.spacing(10)
    },
    tableContent: {
        maxHeight: "calc(100% - 112px)",
        overflowX: "hidden",
        overflowY: "scroll",
        '&::-webkit-scrollbar': {
            width: '0.4em'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            borderRadius: '0.4em'
        }
    },
}));

interface ISoundDashboard {
    aws: AWSContent
    config: any
    frameIO: FrameIOContent
    onClick: (source: string, key: string, format?: string) => void
}
export function SoundDashboard({aws, config, frameIO, onClick}: ISoundDashboard) {
    const classes = useStyles();

    if (! config?.resource_registry?.base?.soundbanks) {
        return (
            <Box display="flex">
                <Typography color="error">
                    There are no sound settings for the project so the build system will not be able to put the data
                    into the correct place. To set up the project update the settings in the open project dialog within
                    Cookbook.
                </Typography>
            </Box>
        );
    }

    const soundBanks = [].concat.apply([], Object.values(config.resource_registry.base.soundbanks))
        .filter((value, index, self) => self.indexOf(value) === index)
        .map((file: string) => file.replace(".bnk", ".zip"));

    return (
        <Box className={classes.table}>
            <Box className={classes.tableRow} display="flex">
                <Box className={classes.tableSoundBank}>
                    <Typography><strong>Sound Bank</strong></Typography>
                </Box>
                <Box className={classes.dateHeader}><Typography><strong>Modified</strong></Typography></Box>
                <Box className={classes.tableCheck}>
                    <Typography><strong>Frame.io</strong></Typography>
                </Box>
                <Box className={classes.tableCheck}>
                    <Typography><strong>AWS</strong></Typography>
                </Box>
            </Box>
            <Box className={classes.tableContent}>
                {soundBanks.map(soundBank => {
                    const frameIoKey = frameIO.getSoundBankKey();
                    const frameIoFile = frameIoKey && frameIO.getFile(frameIoKey);
                    const awsKey = aws.getSoundBankKey(soundBank, config);
                    const awsFile = aws.getFile(awsKey);
                    const color = awsFile && frameIoFile && (awsFile.timestamp > frameIoFile.timestamp) ? "primary" :
                        "warning";

                    return (
                        <Box className={classes.tableRow} key={soundBank}>
                            <Box className={classes.tableSoundBank}>
                                <Typography>{soundBank}</Typography>
                            </Box>
                            <Box className={classes.date}>
                                <Typography title={frameIoFile && new Date(frameIoFile.timestamp).toLocaleString()}>
                                    {frameIoFile ? new Date(frameIoFile.timestamp).toLocaleDateString() : "Unset"}
                                </Typography>
                            </Box>
                            <Box className={classes.tableCheck}>
                                <IconButton color={frameIoFile ? "primary" : "warning"} onClick={() =>
                                    frameIoKey && onClick("frameIo", frameIoKey)}>
                                    {frameIoFile ? <CheckCircle/> : <Cancel/>}
                                </IconButton>
                            </Box>
                            <Box className={classes.tableCheck}>
                                <IconButton color={color} onClick={() =>
                                    onClick("aws", awsKey)}>
                                    {awsFile ? <CheckCircle/> : <Cancel/>}
                                </IconButton>
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}